import React from 'react';
import { MODULES } from '../../../../../common/constants';
import Portal from '../../../../../components/Portal';
import EndUserTabs from '../components/EndUserTabs';
import ReviewTable from '../components/ReviewTable';

const Review = () => (
  <>
    <Portal portalId="header-title-content">
      <div className="portal-header">{MODULES?.END_USER}</div>
    </Portal>
    <EndUserTabs>
      <div className="tab-table">
        <ReviewTable />
      </div>
    </EndUserTabs>
  </>
);

export default Review;
